import DirectionsCarRoundedIcon from "@mui/icons-material/DirectionsCarRounded";
import DirectionsWalkRoundedIcon from "@mui/icons-material/DirectionsWalkRounded";
import s from "./TravelToggle.module.scss";

export type TravelMode = "car" | "foot";

type Props = {
  value: TravelMode;
  onChange: (mode: TravelMode) => void;
  /** The group's name ("How you travel"), and each icon's name ("By car", "On foot"). */
  label: string;
  carLabel: string;
  footLabel: string;
  disabled?: boolean;
  className?: string;
};

/**
 * The small car / on-foot icon pair (design "car-foot" v3): two icon buttons in a quiet track, the chosen one white with the
 * primary colour (`aria-pressed`). Each button's tap area is 48×48 (the extension goes outward, so the two never overlap).
 */
export const TravelToggle = ({ value, onChange, label, carLabel, footLabel, disabled, className }: Props) => (
  <span role="group" aria-label={label} className={[s.track, className].filter(Boolean).join(" ")}>
    <button type="button" className={`${s.btn} ${s.car} ${value === "car" ? s.on : ""}`} aria-pressed={value === "car"} aria-label={carLabel} title={carLabel}
      disabled={disabled} onClick={() => { if (value !== "car") onChange("car"); }}>
      <DirectionsCarRoundedIcon aria-hidden fontSize="inherit" />
    </button>
    <button type="button" className={`${s.btn} ${s.foot} ${value === "foot" ? s.on : ""}`} aria-pressed={value === "foot"} aria-label={footLabel} title={footLabel}
      disabled={disabled} onClick={() => { if (value !== "foot") onChange("foot"); }}>
      <DirectionsWalkRoundedIcon aria-hidden fontSize="inherit" />
    </button>
  </span>
);
